/** @format */

import React, { Component } from 'react';
import { Form, Menu, Dropdown } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import formatNames from '../../../helpers/formatNames';

@inject('RequestsStore', 'ClientsStore')
@observer
class AdvanceClientSearch extends Component {
  renderSearchProps = () => {
    let { ClientsStore } = this.props;
    let list = ['cognome', 'cellulare', 'telefono', 'email'];
    let renderedList = list.map(item => {
      return (
        <Dropdown.Item
          key={'select-' + item}
          onClick={(e, result) => ClientsStore.advancedSearchPropSelect(result)}
        >
          {item}
        </Dropdown.Item>
      );
    });

    return renderedList;
  };

  getPropAlias = value => {
    let translator = {
      surname: 'cognome',
      mobPhone: 'cellulare',
      landPhone: 'telefono',
      email: 'email',
    };

    return translator[value];
  };

  render() {
    let { ClientsStore } = this.props;
    let advancedSearch = ClientsStore.clientsParams.advancedSearch.active;
    return (
      <div
        className={
          advancedSearch
            ? 'advance-search-wrapper open'
            : 'advance-search-wrapper'
        }
      >
        <Form onSubmit={() => ClientsStore.advancedSearch()}>
          <Menu className="advance-toolbar" borderless size="small">
            <Menu.Menu position="left"></Menu.Menu>
            <Menu.Menu position="right">
              <Menu.Item>
                <Form.Input
                  inline
                  size="mini"
                  name="searchValue"
                  value={ClientsStore.clientsParams.advancedSearch.value}
                  onChange={e =>
                    ClientsStore.advancedSearchInput(
                      formatNames(e.target.value),
                    )
                  }
                  placeholder="Digita e premi invio"
                  type="text"
                ></Form.Input>
              </Menu.Item>
              <Menu.Item>
                <Dropdown
                  size="tiny"
                  text={
                    'cerca per ' +
                    this.getPropAlias(
                      ClientsStore.clientsParams.advancedSearch.prop,
                    )
                  }
                >
                  <Dropdown.Menu>{this.renderSearchProps()}</Dropdown.Menu>
                </Dropdown>
              </Menu.Item>
            </Menu.Menu>
          </Menu>
        </Form>
      </div>
    );
  }
}

export default AdvanceClientSearch;
